var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A181E",
    d: "M13.723 11.223c-.337.336-.863.366-1.234.091l-.106-.091L8 6.84l-4.383 4.383c-.336.336-.862.366-1.233.091l-.107-.091c-.336-.337-.366-.863-.091-1.234l.091-.106L7.33 4.83c.336-.336.863-.367 1.234-.092l.106.092 5.053 5.053c.37.37.37.97 0 1.34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpActive);
export default __webpack_public_path__ + "static/media/arrow_up_active.6194f96eb3014e16cc6d7627a315631e.svg";
export { ForwardRef as ReactComponent };